import $ from 'jquery';

class Share {
  constructor() {
    this.facebookShareUrl = 'https://www.facebook.com/sharer/sharer.php?u=';
    this.twitterShareUrl = 'https://twitter.com/intent/tweet/?url=';
    this.listen();
  }

  openDialog(website, shareUrl) {
    window.open(shareUrl, 'website', 'height=285,width=550,resizable=1');
  }

  buildFBUrl(url) {
    return this.facebookShareUrl+encodeURI(url);
  }

  buildTwitterUrl(url, text, user, hashtags) {
    let shareUrl = this.twitterShareUrl + url;
    if (text) {
      shareUrl += '&text='+text;
    }
    if (user) {
      shareUrl += '&via='+user;
    }
    if (hashtags) {
      shareUrl += '&hashtags='+hashtags;
    }
    return shareUrl;
  }

  // TODO: add bunch more params
  buildShareUrl(website, url, text, user, hashtags) {
    switch (website) {
    case 'facebook':
      this.openDialog(website, this.buildFBUrl(url));
      break;
    case 'twitter':
      this.openDialog(website, this.buildTwitterUrl(url, text, user, hashtags));
      break;
    default:
      break;
    }
  }

  listen() {
    $('.ds-share').click((e) => {
      let target = $(e.target).hasClass('ds-share') ? e.target : $(e.target).parents('.ds-share');
      let website = $(target).data('shareTo');
      let url = $(target).data('shareUrl') ? $(e).data('shareUrl') : window.location.href;
      let text = $(target).data('shareText');
      let user = $(target).data('shareUser');
      let hashtags = $(target).data('shareHashtags');
      this.buildShareUrl(website, url, text, user, hashtags);
    });
  }
}

$(document).ready(() => {
  new Share();
});
